import React, { useState } from 'react';

const FormatCarnetModal = ({ isOpen, onClose, onCreated, createFn }) => {
  const [nombreDirectora, setNombreDirectora] = useState('');
  const [cedulaDirectora, setCedulaDirectora] = useState('');
  const [logoFile, setLogoFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!logoFile) { setError('Debe seleccionar un logo (PNG/JPG)'); return; }
    if (!nombreDirectora.trim()) { setError('Debe ingresar el nombre de la directora'); return; }
    if (!cedulaDirectora.match(/^\d{10}$/)) { setError('La cédula debe tener exactamente 10 dígitos'); return; }
    setSubmitting(true);
    try {
      const res = await createFn({ nombreDirectora, cedulaDirectora, logoFile });
      if (res.success) {
        onCreated?.(res.data);
        onClose?.();
      } else {
        setError(res.error || 'No se pudo crear el formato');
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;
  return (
    <div className="modal" style={{ zIndex: 2200 }}>
      <div className="modal-content" style={{ width: 520 }}>
        <div className="modal-header" style={{ background:'#821C53', color:'#fff' }}>
          <h3>Configurar Formato de Carnet</h3>
          <button className="close-btn" onClick={onClose} style={{ color:'#fff' }}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nombre de la Directora</label>
              <input type="text" value={nombreDirectora} onChange={(e)=>setNombreDirectora(e.target.value)} placeholder="Ingresa el nombre completo" />
            </div>
            <div className="form-group">
              <label>Cédula de la Directora</label>
              <input type="text" value={cedulaDirectora} maxLength={10} onChange={(e)=>setCedulaDirectora(e.target.value.replace(/[^\d]/g, ''))} placeholder="Ingresa la cédula (10 dígitos)" />
            </div>
            <div className="form-group">
              <label>Logo (PNG/JPG, máx 2MB)</label>
              <input type="file" accept="image/png, image/jpeg" onChange={(e)=>setLogoFile(e.target.files?.[0]||null)} />
            </div>
            {error && <div style={{ color:'#b00020', marginBottom: 8 }}>{error}</div>}
            <div className="modal-actions">
              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? 'Guardando…' : 'Guardar Formato'}
              </button>
              <button type="button" className="btn-secondary" onClick={onClose} disabled={submitting}>Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormatCarnetModal;
